import { EdgeLoadRequiredDocumentNamesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadRequiredDocumentNames } from '@/shared/domain/use-cases'

export function makeLoadRequiredDocumentNames(): LoadRequiredDocumentNames {
  return new EdgeLoadRequiredDocumentNamesRepository(makeSupabaseEdgeHttpClient()).execute
}
